import type { Projection, ScreenPos, WorldPos } from "./Projection";

export const TOPDOWN_TILE = 32;

export class TopDownProjection implements Projection {
  readonly kind = "topdown" as const;
  readonly tileWidth = TOPDOWN_TILE;
  readonly tileHeight = TOPDOWN_TILE;

  worldToScreen(x: number, y: number): ScreenPos {
    return { sx: x * TOPDOWN_TILE, sy: y * TOPDOWN_TILE };
  }

  tileFoot(x: number, y: number): ScreenPos {
    return { sx: x * TOPDOWN_TILE + TOPDOWN_TILE / 2, sy: y * TOPDOWN_TILE + TOPDOWN_TILE };
  }

  screenToWorld(sx: number, sy: number): WorldPos {
    return { x: sx / TOPDOWN_TILE, y: sy / TOPDOWN_TILE };
  }

  defaultOrigin(viewportW: number, viewportH: number, gridSize: number): ScreenPos {
    const middle = this.worldToScreen(gridSize / 2, gridSize / 2);
    return {
      sx: viewportW / 2 - middle.sx,
      sy: viewportH / 2 - middle.sy,
    };
  }

  /** Rows further down draw on top. */
  depthKey(_x: number, y: number): number {
    return y * 1000;
  }

  /** Identity — keyboard input already in world space for top-down. */
  rotateInputToWorld(rx: number, ry: number): { dx: number; dy: number } {
    return { dx: rx, dy: ry };
  }

  /** No rotation between world and on-screen facing for top-down. */
  worldDirToFrame(dir: number): number {
    return ((dir % 8) + 8) % 8;
  }
}
